"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangeNavigator = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const Elements_1 = require("./Elements");
const constants_1 = require("../../constants");
const Div_1 = require("../Div");
const Text_1 = require("../Text");
const VerticalRule = styled_1.default.hr(() => ({
    color: `${constants_1.Color.GREY}`,
    height: '100%',
    margin: 0,
    padding: 0,
    width: 1,
}));
const RangeNavigator = (props) => {
    return ((0, jsx_runtime_1.jsxs)(Elements_1.RangeUIWrapper, { children: [(0, jsx_runtime_1.jsx)(Elements_1.RangeUIButton, { size: "xs", onClick: () => props.onChange(-1), icon: "ChevronLeftIcon", design: "white" }), (0, jsx_runtime_1.jsx)(VerticalRule, {}), (0, jsx_runtime_1.jsx)(Div_1.Div, { styles: { px: 1, display: 'flex', alignItems: 'center' }, children: (0, jsx_runtime_1.jsx)(Text_1.Text, { bold: true, noSelect: true, fontSize: constants_1.theme.font.size[6], styles: {
                        minWidth: props.minWidth ?? 140,
                        textAlign: 'center',
                        width: '100%',
                    }, children: props.label }) }), (0, jsx_runtime_1.jsx)(VerticalRule, {}), (0, jsx_runtime_1.jsx)(Elements_1.RangeUIButton, { size: "xs", onClick: () => props.onChange(1), icon: "ChevronRightIcon", design: "white" })] }));
};
exports.RangeNavigator = RangeNavigator;
